import { round } from "@acumen/common";

export const getChangeRatePercentage = (currentStat: number, previousStat: number, precision: number) => {
	// NOTE: this is done in order that we get also negative change percentage
	return round((currentStat - previousStat) / previousStat * 100, precision);
};
